// @flow
import { SHOW_SNACKBAR, HIDE_SNACKBAR } from '../constants/snackbar';
import type { Actions } from '../actions/snackbar';

type State = {
  message: string | null,
  triggerSnackbar: number,
  type: string | null,
};

export const initialState: State = {
  message: null,
  triggerSnackbar: 0,
  type: null,
};

/**
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export function snackbar(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case SHOW_SNACKBAR: {
      return {
        ...state,
        message: action.payload.message,
        triggerSnackbar: state.triggerSnackbar + 1,
        type: action.payload.type,
      };
    }

    case HIDE_SNACKBAR: {
      return {
        ...state,
        ...initialState,
      };
    }

    default:
      return state;
  }
}
